import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CContainer,
  CFormSelect,
  CHeaderDivider,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CProgress,
  CProgressBar,
  CRow,
  CTooltip
} from '@coreui/react';
import { Grid, LinearProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { format, isWeekend } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import Moment from 'moment';
import ls from 'local-storage';
import { getAllReviews, getBoothReviews, getSummaryReviews, getTransactionsReviewsTotal } from 'src/services/Reviews';
import { DataGrid } from '@mui/x-data-grid';
import { getBoothsForBranch } from 'src/services/Booths/Booths';
import { json, useNavigate } from 'react-router-dom';
import formatter from 'src/reusables/formatter';
import BoothPicker from 'src/components/BoothPicker';
import DataTable from 'src/components/DataTable';

function Reviews() {
  const [drModal, setDrModal] = useState(false);
  const [boothOptions, setBoothOptions] = useState([]);
  const [tableContent, setTableContent] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  const max = new Date();
  const [formDateRange, setFormDateRange] = useState({
    startDate: new Date(`${Moment(new Date()).startOf('month')}`),
    endDate: new Date(),
    key: 'selection'
  });
  const [dateRange, setDateRange] = useState({
    startDate: new Date(`${Moment(new Date()).startOf('month')}`),
    endDate: new Date(),
    key: 'selection'
  });
  const [boothId, setBoothId] = useState();

  const { height, width, comparison } = useWindowDimensions();
  function goToDetails(row) {
    ls.set('reviewId', row.id);
    // navigate('/transaction-details', { state: params.row });
    if (ls.get('reviewId')) {
      window.open('/reviews-detail', '_blank');
    }
  }

  const tableHeader = [
    { field: 'no', headerName: 'No', width: '100' },
    { field: 'booth_name', headerName: 'Booth', width: '150' },
    { field: 'name', headerName: 'Name', width: '250' },
    { field: 'rating', headerName: 'Rating', width: '100' },
    { field: 'description', headerName: 'Description', width: '250' },
    { field: 'created_date', headerName: 'Date', width: '200' }
  ];

  function handleChangeBooth(val) {
    if (val == boothOptions[0].label) {
      setBoothId();
    } else {
      setBoothId(val);
    }
  }

  function isBoothSet() {
    return ls.get('booth') && ls.get('booth').id !== '0';
  }

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  function fetchBooths() {
    getBoothsForBranch().then((response) => {
      const options = response.data.map((option) => {
        return {
          ...option,
          value: option.id,
          label: `${option.name} - ${option.id}`
        };
      });
      setBoothOptions([
        {
          id: 0,
          value: 0,
          label: 'All Booths'
        },
        ...options
      ]);
    });
  }

  function fetchReviews() {
    getAllReviews('', dateRange.startDate, dateRange.endDate).then((response) => {
      let i = 1;
      setTableContent(
        response.data.map((review) => {
          return {
            ...review,
            no: i++,
            created_date: formatter('completeDate', review.created_at),
            booth_name: `${review.merchant_name} - ${review.booth_id}`
          };
        })
      );
      setTableLoading(false);
    });
  }

  function fetchBoothReviews() {
    getBoothReviews(isBoothSet() ? ls.get('booth').id : '', '', dateRange.startDate, dateRange.endDate).then(
      (response) => {
        let i = 1;
        setTableContent(
          response.data.map((review) => {
            return {
              ...review,
              no: i++,
              created_date: formatter('completeDate', review.created_at),
              booth_name: `${review.merchant_name} - ${review.booth_id}`
            };
          })
        );
        setTableLoading(false);
      }
    );
  }

  useEffect(() => {
    setTableLoading(true);
    fetchBooths();
    if (isBoothSet() ? ls.get('booth').id : '') {
      fetchBoothReviews();
    } else {
      fetchReviews();
    }
  }, [dateRange]);

  return (
    <>
      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
        onClose={() => setDrModal(false)}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setFormDateRange(item.selection);
                ls.set('dateRange', item.selection);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={[formDateRange]}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(false)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setDateRange(formDateRange);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>
      <Grid container className="d-flex justify-content-between">
        <Grid item>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange.startDate).format('ll')}
              {' - '}
              {Moment(dateRange.endDate).format('ll')}
            </div>
          </CButton>
        </Grid>
        <Grid item>
          <BoothPicker />
          {/* <CFormSelect
                    options={boothOptions}
                    onChange={(e) => {
                        handleChangeBooth(e.target.value)
                    }}
                /> */}
        </Grid>
      </Grid>
      <ReviewSummary
        dateFrom={dateRange.startDate}
        dateTo={dateRange.endDate}
        boothId={isBoothSet() ? ls.get('booth').id : ''}
      />
      <CCard>
        <CCardHeader>Reviews</CCardHeader>
        <CCardBody style={tableContent.length > 5 ? {} : { height: '50vh' }}>
          {/* <DataGrid
          columns={tableHeader}
          rows={tableContent}
          loading={tableLoading}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 }
            }
          }}
          pageSizeOptions={[5, 10, 20, 25]}
          onRowClick={(row) => {
            goToDetails(row.row)
          }}
        /> */}
          <DataTable
            columns={tableHeader}
            rows={tableContent}
            loading={tableLoading}
            onRowClick={(row) => {
              goToDetails(row.row);
            }}
          />
        </CCardBody>
      </CCard>
    </>
  );
}

function ReviewSummary({ dateFrom, dateTo, boothId }) {
  const [summary, setSummary] = useState({
    rating: [0, 0, 0, 0, 0],
    total: 0,
    total_customer: 0,
    first_time_customer: 0,
    returning_customer: 0,
    voucher_usage: 0
  });
  const [transactionsCount, setTransactionsCount] = useState(0);

  function calculateSummary() {
    let tot = 0;
    summary.rating.forEach((val, idx) => {
      tot += (idx + 1) * val;
    });
    return (tot / summary.total || 0).toFixed(1);
  }

  function fetchSummary() {
    const startDate = Moment(dateFrom).format('YYYY-MM-DD');
    const endDate = Moment(dateTo).format('YYYY-MM-DD');
    getTransactionsReviewsTotal(boothId, startDate, endDate).then((response) => {
      setTransactionsCount(response.data.total_transactions);
    });
    getSummaryReviews(boothId, startDate, endDate).then((response) => {
      setSummary(response.data);
    });
  }

  useEffect(() => {
    fetchSummary();
  }, [dateFrom, dateTo]);
  return (
    <CCard className="mb-3">
      <CCardHeader>Summary</CCardHeader>
      <CCardBody>
        <CRow className="mb-2 pb-1 border-bottom">
          <CCol md={8} xs={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            {summary.rating.map((val, idx) => {
              return (
                <CRow key={`rating-${idx}`} className="mb-1">
                  <CCol xs={1}>{idx + 1}</CCol>
                  <CTooltip content={val}>
                    <CCol className="d-flex align-items-center">
                      <CContainer style={{ flex: 1 }}>
                        <CProgress value={(val / summary.total) * 100} />
                      </CContainer>
                    </CCol>
                  </CTooltip>
                </CRow>
              );
            })}
          </CCol>
          <CCol md={4} xs={12}>
            <CRow className="text-center">
              <h1 style={{ fontSize: '6cqh' }}>{calculateSummary()}</h1>
            </CRow>
            <CRow className="text-center">
              <h4>{formatter('number', summary.total)} reviews</h4>
            </CRow>
            <CRow className="text-center">
              <h4>{formatter('number', transactionsCount)} transactions</h4>
            </CRow>
            <CRow className="text-center">
              <h4>
                {`${(transactionsCount != 0 ? (summary.total * 100) / transactionsCount : 0).toFixed(1)}% reviewed`}
              </h4>
            </CRow>
          </CCol>
        </CRow>
        <CRow>
          <CCol md={6} xs={12} className="text-center">
            <h5>{`Vouchers Generated: ${summary.total}`}</h5>
          </CCol>
          <CCol md={6} xs={12} className="text-center">
            <h5>{`Vouchers Used: ${summary.voucher_usage}`}</h5>
          </CCol>
          <CCol md={6} xs={12} className="text-center">
            <h5>{`Gained Customer: ${summary.first_time_customer}`}</h5>
          </CCol>
          <CCol md={6} xs={12} className="text-center">
            <h5>{`Returning Customer: ${summary.returning_customer}`}</h5>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
}
export default Reviews;
